export default {
  auth: {
    email: 'Email',
    name: 'Name',
    password: 'Passwort',
    sign_in_submit: 'Anmelden',
    sign_in_message: 'Melden Sie sich mit Ihrem Account an',
    verification_code: 'Verification-Code',
    verification_code_tip:
      'Über die Google Authenticator App erhalten Sie einen 6-stelligen Code, der hier einzugeben ist',
    activate_authenticator: 'Authenticator aktivieren',
  },
  user: {
    first_name: 'Vorname',
    last_name: 'Nachname',
    user_not_found: 'User nicht gefunden',
    cannot_remove_yourself: 'Sie können sich nicht selbst löschen',
  },
  app: {
    back: 'Zurück',
    submit_form_final: 'Berechnen',
    submit_form_next: 'Nächster',
    send: 'Abschicken',
  },
  errors: {
    number_invalid: 'Bitte eine Zahl eingeben',
    min_value: 'Der Wert muss mindestens {min} sein',
    max_value: 'Der Wert darf höchstens {max} sein',
    fill_field: 'Bitte dieses Feld ausfüllen!',
    choose_one: 'Bitte Auswahl treffen',
    no_server_response:
      'Verbindung zum Server derzeit nicht möglich, bitte Internetverbindung überprüfen bzw. später nochmals versuchen',
    email_required: 'Email-Adresse ist erforderlich!',
    password_required: 'Passwort ist erforderlich!',
    required: 'erforderlich',
    email_invalid: 'Email-Adresse ungültig',
  },
  page_not_found: {
    title: 'Seite nicht gefunden',
    back: 'Zurück',
  },
  buttons: {
    save: 'Sichern',
    submit: 'Überprüfen',
    cancel: 'Abbrechen',
    back: 'Zurück',
    unassign: 'Nicht zugewiesen',
    delete: 'Löschen',
  },
  init2FA: {
    configure_code_generator: 'Google Authenticator konfigurieren',
    steps:
      '<ol><li>Download der Google Authenticator App am Smartphone von </li>the <a>href={playMarketLink} Play Market</a> or the <a>href={appStoreLink} App Store</a> <li>In unserer Anwendung erstellen Sie einen Benutzer und melden Sie diesem dem internen Produktmanager</li><li>Wählen Sie Scan Barcode</li><li>Sie erhalten von der Authenticator App einen 6-stelligen Code</li><li>Geben diesen hier ein und drücken Sie "Überprüfen".\n Wenn der Code korrekt ist, bekommen Sie in in den Admin-Bereich.\n Fall der Code nicht korrekt ist, bitte nochmals versuchen.</li></ol>',
  },
  expressLoan: {
    total_account_fees: 'Kontoführung gesamt',
    execution_fee: 'Hypothekeneintragungsgebühr',
    changes_applied: 'Die Änderungen wurden erfolgreich gespeichert',
  },
  loan: {
    variable_interest_rate: 'Variabler Zinssatz',
    fixed_interest_rates: 'Fixer Zinssatz für {period} Jahre',
    loan_costs: 'Kreditnebenkosten',
    loan_costs_fix: 'Kreditnebenkosten fix',
    sk1_factor: 'Individueller SK1 Faktor',
    sk1: 'SK1',
    period: 'Periode',
    interest_rate: 'Zinssatz',
    loan_period: 'Laufzeit / SK1',
    years: '{period} J',
    changes_applied: 'Die Änderungen wurden erfolgreich gespeichert',
    recalculate_all_projects: 'Alle Projekte neu berechnen',
    recalculation_success: 'Änderungen erfolgreich',
    lastUpdated: 'Zuletzt geändert von {user}. At - {time}',
    own_funds_ratio: 'Eigenmittelanteil',
    max_loan_rate_ration: 'Anteil Rate am Einkommen',
    interest_bandwith: 'Zinsbandbreite',
  },
  messages: {
    answer_required: 'Bitte eine Antwort eingeben',
    not_found: 'Nachricht nicht gefunden',
    back_to_messages: 'Zurück zu den Nachrichten',
    saved_without_email: 'Antwort gespeichert, keine E-Mail: Gast ohne E-Mail-Adresse',
    feedback: 'Feedback',
    userMessage: 'Ihre Nachricht',
    responded: 'Beantwortet',
    unresponded: 'Unbeantwortet',
    filter: 'Filter',
    message_sent: 'Nachricht wurde gesendet',
    empty: 'Keine Nachrichten',
    name: 'Name',
    message: 'Nachricht',
    date: 'Datum',
    placeholder_for_editor:
      'Schreiben Sie hier Ihre Nachricht, oder fügen Sie diese mit copy & paste ein',
  },
  reports: {
    form: {
      date_range: '@Date range',
    },
    type: {
      projects: '@Projects',
      registered_users: '@Registered users',
      loan_consultants: '@Loan consultants',
      customer_data_analytics: '@Customer data analytics',
    },
    export_btn: '@Export',
    generate_report: '@Generate report',
  },
  projects: {
    filter: 'Filter',
    name: 'Name',
    type: 'Projekttyp',
    price: 'Preis',
    pdf: 'Pdf',
    creator: 'Ersteller',
    created: 'Angelegt',
    registration_date: 'Registrierungsdatum',
    last_updated: 'Zuletzt geändert',
    not_assigned: 'nicht angemeldet',
    report_about_registered_users: 'Bericht über registrierte User',
    clientIP: 'Client IP',
    archived: 'Archiviert',
    types: {
      new_building: 'Neubau eines Einfamilienhauses',
      new_apartment: 'Kauf einer Wohnung',
      buying_house: 'Kauf Einfamilienhaus (inkl. Sanierung)',
      renovation_house: 'CO₂-Bilanz & Sanierung Haus',
      property_valuation: 'Immobilienbewertung',
      lifestyle_calculator: 'Lifestyle Kalkulator',
    },
  },
  loan_consultants: {
    title: 'Kreditberater',
    loan_consultant_added: 'Kreditberater hinzugefügt',
    delete_loan_consultant: 'Kreditberater-Rolle löschen',
    delete_loan_consultant_message:
      'Sind Sie sicher, dass die Berater-Rolle für diesen Berater gelöscht werden soll: - {name}',
    loan_consultant_deleted: 'Berater-Rolle wurde gelöscht',
    delete: 'Löschen',
    download_btn: 'Bericht downloaden',
    add_loan_consultant_btn: 'Kreditberater hinzufügen',
    name: 'Name',
    email: 'Email',
  },
  admins: {
    title: 'Admins',
    add_admin_btn: 'Admin hinzufügen',
    unassign: 'Entfernen',
    unassign_admin: 'Admin entfernen',
    unassign_admin_message:
      'Sind Sie sicher, dass Sie dass Sie {name} als Admin entfernen möchten?',
    assigned: 'Der Admin-User wurde hinzugefügt',
    unassigned: 'Administrator entfernt',
    name: 'Name',
    email: 'Email',
  },
  notifications: {
    empty: 'Keine Benachrichtigungen',
    message: 'Nachricht',
    date: 'Datum',
  },
  select_values: {
    not_important: 'Nicht wichtig',
    important: 'Wichtig',
    very_important: 'Sehr wichtig',
  },
  financing_requests: {
    project_name: 'Projektname',
    email: 'Email',
    sender: 'Sender',
    created_at: 'Erstellt am',
    user: 'User',
    message: 'Nachricht',
    empty: 'No requests',
    download: 'Download als pdf',
  },
  customer_data_analytics: {
    generate_report: 'Bericht erstellen',
    customer_name: 'Kundenname',
    customer_email: 'Kunden-Mail',
    ip_address: 'IP-Addresse',
    alone_or_partner: 'Partnerschaft',
    age: 'Geb-Dat',
    created_at: 'Erstellt',
    kids_quantity: 'Kinder',
    monthly_net_salary: 'Einkommen',
    monthly_net_salary_partner: 'Einkommen Partner',
    other_revenues: 'Sonstige Einkünfte',
    amount_with_loan_costs: 'Kreditbetrag',
    last_project_type: 'Projekttyp',
    last_project_created_at: '@Last project created at',
    new_car: 'Neues Auto',
    savings: 'Sparen',
    luxuries: 'Shopping, Beauty',
    hobbies: 'Hobbies',
    pension_and_insurances: 'Vorsorge und Versicherung',
    socializing: 'Kulinarisches, Gäste',
    taking_a_break: 'Reisen',
    technology: 'Technologie',
    pdf: 'PDF',
  },
  co2_report: {
    category_name: 'CO₂ relevante Kategorie',
    number_of_status_planned: `Anzahl im Status 'geplant'`,
    number_of_status_progress: `Anzahl im Status 'in Umsetzung'`,
    number_of_status_done: `Anzahl im Status 'umgesetzt'`,
    co2_savings: 'CO₂ Einsparung t/a',
    solar_power_system: 'PV-Anlagen',
    heating_exchange: 'Heizungstausch',
    window_exchange: 'Fenstertausch',
    facade_insulation: 'Fassadendämmung',
    coming_soon: 'Coming soon',
    new_windows: 'Fenstertausch',
    insulation_top_ceiling: 'Dämmung o. Geschossdecke',
    insulation_basement_ceiling: 'Dämmung Kellerdecke',
    insulation_facade: 'Fassadendämmung',
    controlled_living_space_ventilation: 'Kontrollierte Wohnraumlüftung',
    heating_system: 'Heizungstausch',
    go_to_details: 'Details..',
    back_to_co2_report: 'Zurück zum CO₂-Bericht',
    username: 'User-Name',
    energy_ghg_balance_before: 'Energie-Bilanz (CO2) vor der Planung',
    energy_ghg_balance_after: 'Energie-Bilanz (CO2) nach der Planung',
  },
  hypo_noe_api_request: {
    project_name: '@Project name',
    project_type: '@Project type',
    details: '@Details',
    purchase_price: '@Purchase price',
    parameter: '@Parameter',
    value: '@Value',
    customers: '@Customers',
    status: '@Status',
    error: '@Error',
    user_info: '@User info',
    guest: '@Guest',
    created_at: '@Created at',
    retry_request: '@Retry request',
    request_not_found: '@Request not found',
  },
  page_titles: {
    reports: '@Reports',
    login: 'Anmelden',
    projects: 'Projekte',
    analytics: 'Analytics',
    loan: 'Finanzierung',
    express_loan_settings: '@Express loan settings',
    logout: 'Abmelden',
    admins: 'Administratoren',
    messages: 'Nachrichten',
    login2FA: 'Authenticator',
    notifications: 'Notifications',
    financing_requests: 'Finanzierungsanfragen',
    loan_consultants: 'Kreditberater',
    customer_data_analytics: 'Kundenanalyse',
    co2_report: 'CO2-Reporting',
    hypo_noe_api_requests_report: '@HYPO-NOE API requests',
  },
};

export const backendErrors = {
  access_denied: 'Zugriff nicht möglich, bitte etwas später nochmals versuchen',
  something_went_wrong: 'Sorry, etwas lief falsch - bitte etwas später nochmals versuchen',
  form_data_is_missing: 'Eingaben im Formular fehlen',
  auth: {
    login_failed: 'Login fehlgeschlagen - bitte nochmals versuchen',
    email_exists: 'Es existiert bereits ein User mit dieser Email-Adresse',
    verify_account: 'Email-Adresse muss noch bestätigt werden',
    password_is_required: 'Passwort eingeben',
    not_authorized: 'Nicht berechtigt',
    temporary_password_is_required:
      'Für Ihr Erstlogin benötigen Sie das zugesendete Start-Passwort',
    wrong_password: 'Falsches Passwort',
    account_has_no_password:
      'Ihr Account hat kein Passwort da Sie sich mit Google oder Facebook registriert haben',
  },
  user: {
    user_not_found: 'User nicht gefunden',
  },
  project: {
    not_found: 'Projekt nicht gefunden',
  },
  invitation: {
    email_exists: 'Mit dieser Email-Adresse gibt es bereits einen User',
    cannot_resend_temp_password: `Sie können kein neues Startpasswort versenden, da der User/Kunde es bereits geändert hat`,
    cannot_delete_invited_user: `Sie können den Kunden-Account nicht löschen, da der Kunde bereits das Startpasswort geändert`,
  },
  admin: {
    disable_2_fa: 'Disable 2FA before initiating it again.',
    otp_is_invalid: 'One-time password is not valid. Please try again',
    last_admin: 'Sie sind der letzte Admin',
    otp_is_required: 'Bitte das Einmal-Passwort eingeben',
  },
  hypo_noe_api_request: {
    request_not_found: '@Request not found',
    retry_is_not_available:
      '@Unfortunately, you could not resubmit this request because it was successful',
  },
};
